import React from 'react';
import cn from 'classnames';

import css from './style.module.scss';

interface prop {
  classNames?: string;
  children?: React.ReactNode;
}

const VipPlateIcon: React.FC<prop> = ({ children, classNames }) => {
  return (
    <div className={cn(css.gold, classNames)}>
      {children}
      <img src="/img/VIP/crown.svg" alt="" width={12} />
      <span>VIP</span>
    </div>
  );
};

export default VipPlateIcon;
